import {
    ISaveSupportTypeFrequencies,
    ISupportTypeFrequenciesQuery,
    ISupportTypeFrequency,
    supportApi,
} from '../../shared';
import { NewBaseClient } from '../../shared/clients/new-base.client';

class SupportTypeFrequencyClient extends NewBaseClient<
    ISaveSupportTypeFrequencies,
    ISupportTypeFrequency,
    ISupportTypeFrequenciesQuery
> {
    constructor() {
        super(supportApi, '/support-type-frequencies');
    }
}

export const supportTypeFrequencyClient = new SupportTypeFrequencyClient();
